import { useState } from 'react'
import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import { SpaceButtons } from '@ui/buttons/ButtonsFixed'
import { useOrderState } from '@order/hooks/useOrderState'
import CustomerModal from '@order/modals/Checkout/Customer/CustomerModal'
import OrderInvoiceModal from '@user/customer/modals/Account/Invoice/OrderInvoiceModal'
import { PoliciesModal, PoliciesSection } from '@user/customer/policies'
import OrderCustomer from './sections/OrderCustomer'
import OrderInvoice from './sections/OrderInvoice'
import OrderCheckoutButtons from './ConfirmButtons'
import { useConfirmCustomer } from '@user/customer/confirmation/useConfirmCustomer'
import useOrderConfigure from '@order/hooks/useOrderConfigure'
import Checkbox from '@ui/forms/Checkbox'

type ModalName = 'customer' | 'invoice' | 'policies'

export default function OrderBilling() {
  const { t } = useTranslation(['order', 'modals', 'ui', 'types', 'summary'])
  const text = 'order:billing'
  const [modal, setModal] = useState<ModalName | null>(null)
  const { isLoading } = useOrderConfigure(false)
  const resetModal = () => setModal(null)
  const { invoice, isInvoiceRequired } = useConfirmCustomer()
  const isInvoiceEnabled = useOrderState((s) => s.order.invoice)
  const setUseInvoice = useOrderState((s) => s.setUseInvoice)
  const toggleInvoice = () => {
    if (!invoice?.data) {
      setModal('invoice')
      return
    }
    setUseInvoice(!isInvoiceEnabled)
  }

  return (
    <>
      <Page stage="order">
        <Header
          title={t(`${text}.header.title`)}
          desc={t(`${text}.header.desc`)}
        />
        <View className="flex flex-col gap-8 px-8">
          <View className="flex flex-row items-start justify-between gap-8">
            <View className="flex-1">
              <OrderCustomer onPress={() => setModal('customer')} />
              <View className="flex-1 px-8 py-6">
                <Checkbox
                  disabled={isInvoiceRequired}
                  value={isInvoiceRequired || isInvoiceEnabled}
                  onChange={toggleInvoice}
                  label={t('modals:invoice.use')}
                />
              </View>
            </View>
            <View className="flex-1 gap-6">
              <OrderInvoice onPress={() => setModal('invoice')} />
              <PoliciesSection onPress={() => setModal('policies')} />
            </View>
          </View>
        </View>
        <SpaceButtons />
      </Page>
      <OrderCheckoutButtons
        isLoading={isLoading || invoice?.isLoading}
        onPoliciesRequired={() => setModal('policies')}
      />
      <CustomerModal close={resetModal} open={modal === 'customer'} />
      <OrderInvoiceModal close={resetModal} open={modal === 'invoice'} />
      <PoliciesModal close={resetModal} open={modal === 'policies'} />
    </>
  )
}
